	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Asset.ImageResolver;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Asset/ImageResolver.js
// module id = 17
// module chunks = 0